var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirdrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2086_11525)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.38477,
    y: 6.42285,
    width: 57.6923,
    height: 57.6923,
    rx: 12.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2279 18.1575C39.2813 18.1569 43.2166 19.522 46.3991 22.0323C49.5816 24.5426 51.8256 28.0518 52.769 31.9939C53.7125 35.9359 53.3005 40.0808 51.5995 43.76C49.8984 47.4391 47.0075 50.4379 43.3931 52.2726C42.8139 52.5667 42.5827 53.2746 42.8767 53.8538C43.1707 54.433 43.8786 54.6642 44.4578 54.3702C48.5437 52.2962 51.8116 48.9062 53.7346 44.7472C55.6575 40.5881 56.1233 35.9025 55.0567 31.4463C53.9902 26.9901 51.4535 23.0232 47.8559 20.1854C44.2584 17.3476 39.8097 15.8046 35.2276 15.8052C30.6456 15.8058 26.1973 17.3499 22.6005 20.1886C19.0036 23.0273 16.4679 26.9949 15.4025 31.4514C14.3371 35.9079 14.8041 40.5933 16.7281 44.7519C18.6521 48.9104 21.9209 52.2996 26.0072 54.3725C26.5865 54.6664 27.2944 54.435 27.5882 53.8557C27.8821 53.2764 27.6507 52.5686 27.0714 52.2747C23.4566 50.441 20.5649 47.4429 18.8629 43.7642C17.1609 40.0854 16.7478 35.9406 17.6903 31.9983C18.6328 28.0561 20.8759 24.5463 24.0577 22.0351C27.2396 19.524 31.1746 18.158 35.2279 18.1575Z",
    fill: "url(#paint0_linear_2086_11525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4558 25.7024C41.1076 23.8611 38.2095 22.8609 35.2255 22.8621C32.2414 22.8632 29.3441 23.8656 26.9973 25.7088C24.6506 27.5519 22.9901 30.1292 22.2819 33.0279C21.5736 35.9267 21.8585 38.9793 23.091 41.6969C24.3234 44.4146 26.4321 46.6401 29.0794 48.0171C29.6556 48.3169 29.8798 49.027 29.58 49.6033C29.2803 50.1795 28.5701 50.4037 27.9939 50.1039C24.8794 48.4839 22.3986 45.8657 20.9487 42.6684C19.4988 39.4712 19.1636 35.8799 19.9968 32.4696C20.8301 29.0593 22.7835 26.0272 25.5444 23.8588C28.3053 21.6904 31.7139 20.5111 35.2245 20.5098C38.7352 20.5084 42.1447 21.6851 44.9073 23.8513C47.6698 26.0176 49.6256 29.0482 50.4615 32.4579C51.2974 35.8675 50.965 39.459 49.5175 42.6574C48.0701 45.8557 45.5913 48.4759 42.4781 50.0983C41.9021 50.3985 41.1917 50.1749 40.8915 49.5989C40.5913 49.0229 40.8149 48.3125 41.391 48.0123C44.0372 46.6333 46.1442 44.4061 47.3745 41.6875C48.6048 38.9689 48.8874 35.9161 48.1769 33.0179C47.4664 30.1197 45.804 27.5437 43.4558 25.7024Z",
    fill: "url(#paint1_linear_2086_11525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2259 27.5666C37.143 27.5655 39.0058 28.2032 40.5201 29.3788C42.0344 30.5544 43.1138 32.2011 43.5879 34.0586C44.0621 35.9161 43.9038 37.8787 43.1382 39.6362C42.3726 41.3938 41.0432 42.8462 39.3601 43.764C38.7898 44.075 38.5796 44.7894 38.8906 45.3597C39.2016 45.93 39.916 46.1402 40.4863 45.8292C42.6284 44.6611 44.3203 42.8126 45.2947 40.5757C46.2692 38.3388 46.4706 35.841 45.8672 33.4768C45.2637 31.1127 43.8899 29.017 41.9626 27.5207C40.0353 26.0245 37.6645 25.2129 35.2246 25.2143C32.7846 25.2157 30.4147 26.03 28.4891 27.5284C26.5636 29.0269 25.1921 31.1242 24.5914 33.489C23.9907 35.8538 24.1949 38.3514 25.1719 40.5872C26.1489 42.8229 27.8429 44.6695 29.9864 45.8352C30.557 46.1455 31.2712 45.9345 31.5815 45.3639C31.8919 44.7932 31.6808 44.079 31.1102 43.7687C29.426 42.8528 28.095 41.4019 27.3274 39.6453C26.5598 37.8886 26.3993 35.9262 26.8713 34.0681C27.3433 32.2101 28.4208 30.5622 29.9338 29.3848C31.4467 28.2075 33.3088 27.5677 35.2259 27.5666Z",
    fill: "url(#paint2_linear_2086_11525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5864 33.0582C36.905 32.5458 36.0751 32.2695 35.2225 32.2712C34.3699 32.2728 33.5412 32.5524 32.8617 33.0674C32.1823 33.5825 31.6893 34.3049 31.4574 35.1254C31.2256 35.9458 31.2675 36.8195 31.5768 37.614C31.8861 38.4084 32.4459 39.0804 33.1715 39.5281C33.7243 39.8692 33.8959 40.5939 33.5548 41.1467C33.2138 41.6995 32.4891 41.8711 31.9363 41.53C30.7754 40.8137 29.8796 39.7385 29.3847 38.4673C28.8899 37.1962 28.8228 35.7983 29.1938 34.4856C29.5648 33.1729 30.3536 32.017 31.4407 31.1929C32.5278 30.3688 33.8538 29.9216 35.2179 29.9189C36.582 29.9162 37.9098 30.3583 39.0001 31.1782C40.0904 31.998 40.8837 33.1509 41.2598 34.4621C41.6359 35.7734 41.5743 37.1715 41.0843 38.4446C40.5944 39.7177 39.7028 40.7964 38.5447 41.5172C37.9932 41.8604 37.2679 41.6916 36.9247 41.1401C36.5815 40.5886 36.7503 39.8633 37.3017 39.5201C38.0256 39.0696 38.5828 38.3954 38.889 37.5997C39.1952 36.804 39.2337 35.9302 38.9987 35.1107C38.7636 34.2912 38.2678 33.5706 37.5864 33.0582Z",
    fill: "url(#paint3_linear_2086_11525)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7985 36.1916C36.7985 37.0577 36.0964 37.7598 35.2304 37.7598C34.3643 37.7598 33.6622 37.0577 33.6622 36.1916C33.6622 35.3256 34.3643 34.6235 35.2304 34.6235C36.0964 34.6235 36.7985 35.3256 36.7985 36.1916Z",
    fill: "url(#paint4_linear_2086_11525)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2086_11525",
    x: 0.615535,
    y: 0.653621,
    width: 69.2299,
    height: 69.2308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.88462
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2086_11525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2086_11525",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2086_11525",
    x1: 46.9916,
    y1: 18.9405,
    x2: 28.9197,
    y2: 51.8966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F97F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2086_11525",
    x1: 46.9916,
    y1: 18.9405,
    x2: 28.9197,
    y2: 51.8966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F97F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2086_11525",
    x1: 46.9916,
    y1: 18.9405,
    x2: 28.9197,
    y2: 51.8966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F97F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2086_11525",
    x1: 46.9916,
    y1: 18.9405,
    x2: 28.9197,
    y2: 51.8966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F97F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2086_11525",
    x1: 46.9916,
    y1: 18.9405,
    x2: 28.9197,
    y2: 51.8966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F97F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdrop);
export default __webpack_public_path__ + "static/media/airdrop.8f0e42b137265bfba6df06d2eb135ea6.svg";
export { ForwardRef as ReactComponent };